import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-inputgroup" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AutoComplete = _resolveComponent("AutoComplete")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_AutoComplete, {
      completeOnFocus: "",
      modelValue: _ctx.searchBox,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.searchBox = $event)),
      suggestions: _ctx.suggestions,
      field: "name",
      placeholder: "Cerca fascia oraria",
      onItemSelect: _ctx.onSelect,
      onComplete: _ctx.search,
      style: {"width":"250px"}
    }, null, 8, ["modelValue", "suggestions", "onItemSelect", "onComplete"])
  ]))
}